<div *ngIf="global_texts && question" class="all-content">
  <div class="">
    <app-header></app-header>
  </div>
  <div class="content">
    <div class="inner-content">

      <div class="sidebar-content">
        <app-sidebar></app-sidebar>
      </div>

      <div>
        <!-- TO DELETE LATER -->
        <!--        <div class="p-3 bg-green color-white">-->
        <!--          <h1 class="fw-bold">Devenez des experts dans la façon de penser les plaies</h1>-->
        <!--        </div>-->
        <div class="mt-5 mt-md-3 p-3 p-lg-5">
          <div class="d-flex">

            <div class="self-module">
              <!-- Bubble Title -->

              <div class="bubble-step mb-5"
                   [class.biggest-pad-top]="question.title == titleCasComptoir1"
                   [class.bg-red]="is_answer_explanation_visible">
                <div class="title">
                  <h1 *ngIf="!is_answer_explanation_visible">
                    <span *ngIf="!question.title; else qstHasTitle" [innerHtml]="global_texts.question + ' ' +
                    current_qst_index + '/5'"></span>
                    <ng-template #qstHasTitle>
                      <span [innerHtml]="question.title"></span>
                    </ng-template>
                  </h1>
                  <h1 *ngIf="is_answer_explanation_visible">
                    <span *ngIf="!question.title; else qstHasTitle" [innerHtml]="global_texts.answer"></span>
                    <ng-template #qstHasTitle>
                      <span [innerHtml]="question.title"></span>
                      <span *ngIf="answer_explanation?.additional_text_title"
                            [innerHtml]="answer_explanation?.additional_text_title"></span>
                    </ng-template>
                  </h1>
                </div>

                <!-- /// Bubble Content /// -->
                <!-- Label Question -->
                <h1 *ngIf="!is_answer_explanation_visible" class="text-bubble-step fw-bold color-red text-start"
                    [innerHtml]="question.label"></h1>

                <!-- Additional text under question label -->
                <!-- Old condition hidden : && question.type != QstTypes.DropzoneSingle-->
                <!-- Old class : fst-italic // New class : fw-bold-->
                <h4 class="text-start mt-3"
                    *ngIf="!is_answer_explanation_visible && current_qst_additional_text"
                    [innerHtml]="current_qst_additional_text"></h4>

                <!-- Question type -->
                <div *ngIf="question" class="py-3">
                  <div [ngSwitch]="question.type">

                    <app-radio-inline *ngSwitchCase="QstTypes.RadioInline"
                                      [class]="current_qst_class"
                                      [question]="question"
                                      [answers]="question.answers_options"
                                      [disabled]="is_answer_explanation_visible"
                                      (answerSelected)="onAnswerSelected($event)"></app-radio-inline>

                    <app-radio *ngSwitchCase="QstTypes.Radio"
                               [class]="current_qst_class"
                               [question]="question"
                               [answers]="question.answers_options"
                               [disabled]="is_answer_explanation_visible"
                               (answerSelected)="onAnswerSelected($event)"></app-radio>

                    <app-checkbox *ngSwitchCase="QstTypes.Checkbox"
                                  [class]="current_qst_class"
                                  [question]="question"
                                  [answers]="question.answers_options"
                                  [disabled]="is_answer_explanation_visible"
                                  (answerSelected)="onAnswerSelected($event)"></app-checkbox>

                    <app-dropzone-multiple *ngSwitchCase="QstTypes.DropzoneMultiple"
                                           [class]="current_qst_class"
                                           [question]="question"
                                           [answers]="question.answers_options"
                                           [disabled]="is_answer_explanation_visible"
                                           [txt_in_drop_zone]="current_qst_additional_text_drop_zone"
                                           (answerSelected)="onAnswerSelected($event)"></app-dropzone-multiple>

                    <app-dropzone-single *ngSwitchCase="QstTypes.DropzoneSingle"
                                         [class]="current_qst_class"
                                         [question]="question"
                                         [additional_text]="(current_qst_additional_text_drop_zone) ? current_qst_additional_text_drop_zone : current_qst_additional_text"
                                         [answers]="question.answers_options"
                                         [disabled]="is_answer_explanation_visible"
                                         (answerSelected)="onAnswerSelected($event)"></app-dropzone-single>
                  </div>

                </div>

                <!-- Annexes -->
                <div *ngIf="!is_answer_explanation_visible && current_screen_annexes">
                  <app-annexes [annexes]="current_screen_annexes"></app-annexes>
                </div>

                <!-- Asterisks -->
                <div *ngIf="!is_answer_explanation_visible && current_screen_asterisks">
                  <app-asterisks [asterisks]="current_screen_asterisks"></app-asterisks>
                </div>

                <!-- Small Texts -->
                <div *ngIf="!is_answer_explanation_visible && current_screen_small_texts">
                  <app-small-texts [smallTexts]="current_screen_small_texts"></app-small-texts>
                </div>

                <!-- Answer Explanation -->
                <div *ngIf="is_answer_explanation_visible && answer_explanation">

                  <div class="text-bubble-step text-start">
                    <!-- Title -->
                    <h1 class="d-block fw-bold color-{{answer_explanation.color_title}} py-3 text-uppercase"
                        [innerHtml]="answer_explanation.title"></h1>

                    <!-- RespTypes : Default -->
                    <div *ngIf="answer_explanation_type == RespTypes.Default">
                      <!-- Text -->
                      <h3 [innerHtml]="answer_explanation.text"></h3>
                      <!-- Image -->
                      <div class="my-4" *ngIf="answer_explanation?.image">
                        <img [src]="answer_explanation.image">
                      </div>
                    </div>

                    <!-- RespTypes : ImageLeftAndTextRight -->
                    <div *ngIf="answer_explanation_type == RespTypes.ImageLeftAndTextRight"
                         class="d-flex flex-column flex-md-row gap-4 align-items-center">
                      <!-- Image -->
                      <div *ngIf="answer_explanation?.image">
                        <img [src]="answer_explanation.image">
                      </div>
                      <!-- Text -->
                      <h3 [innerHtml]="answer_explanation.text"></h3>
                    </div>

                    <!-- RespTypes ImagesPlusPopup -->
                    <div *ngIf="answer_explanation_type == RespTypes.ImagesPlusPopup">
                      <!-- Text -->
                      <h3 [innerHtml]="answer_explanation.text"></h3>
                      <ng-container *ngTemplateOutlet="ImagesPlusPopupTemplate; context: { data:
                      answer_explanation_other_datas }"></ng-container>
                    </div>

                  </div>

                  <!-- Annexes -->
                  <div *ngIf="annexes_answer_explanation" class="text-center">
                    <app-annexes [annexes]="annexes_answer_explanation"></app-annexes>
                  </div>

                  <!-- Asterisks -->
                  <!--                  <div *ngIf="current_screen_asterisks">-->
                  <!--                    <app-asterisks [asterisks]="current_screen_asterisks"></app-asterisks>-->
                  <!--                  </div>-->

                  <!-- Small Texts -->
                  <div class="pt-3" *ngIf="small_texts_answer_explanation">
                    <app-small-texts [smallTexts]="small_texts_answer_explanation"></app-small-texts>
                  </div>


                </div>

                <!-- Button -->
                <div
                  class="mt-5 d-flex flex-column flex-md-row align-items-center justify-content-center flex-wrap gap-3">
                  <!-- Add condition If is not correct -->
                  <button #buttonTryAgain *ngIf="has_button_try_again && is_answer_explanation_visible &&
                  !answer_is_correct"
                          class="btn btn-lined-green text-uppercase"
                          [innerHtml]="global_texts.try_again"
                          (click)="tryAgainSameQuestion()">
                  </button>
                  <button #buttonCheckAnswer *ngIf="!is_answer_explanation_visible"
                          class="btn btn-solid-green text-uppercase"
                          [disabled]="disableButtonValidate()"
                          [innerHtml]="global_texts.validate"
                          (click)="checkAnswer()">
                  </button>
                  <button #buttonNext *ngIf="is_answer_explanation_visible" class="btn btn-solid-green text-uppercase"
                          (click)="app.sharedHelper.goToNextScreen()"
                          [innerHtml]="global_texts.next">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <app-footer></app-footer>
    </div>
  </div>
</div>

<ng-template #ImagesPlusPopupTemplate let-data="data">
  <div class="my-5">
    <div class="d-flex flex-column flex-md-row gap-5 gap-md-3">
      <div *ngFor="let item of data" class="flex-fill position-relative">
        <img role="button" (click)="openModalRespExplanation(item)" [src]="item.image" class="img-fluid">
        <a class="position-absolute btn btn-solid-green btn-more"
           (click)="openModalRespExplanation(item)">
          <span class="material-icons">add</span>
        </a>
      </div>
    </div>
  </div>
</ng-template>

